import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';

const FeatureAuth = ({ children, featureName }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authUsername, setAuthUsername] = useState('');
  const [passcode, setPasscode] = useState('');

  // Check if auth is still valid on component mount
  useEffect(() => {
    const checkAuth = () => {
      const authData = localStorage.getItem(`${featureName}_auth`);
      if (authData) {
        const { expiry } = JSON.parse(authData);
        if (expiry > Date.now()) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem(`${featureName}_auth`);
        }
      }
    };
    checkAuth();
  }, [featureName]);

  const validateCredentials = (username, passcode) => {
    const storedUsername = localStorage.getItem('username');
    
    if (!storedUsername || username !== storedUsername) {
      return false;
    }

    let expectedPasscode;
    if (featureName === 'freeGameScheduler') {
      expectedPasscode = `${username}8099`;
    } else if (featureName === 'bonusManagement') {
      expectedPasscode = `${username}8066`;
    }

    return passcode === expectedPasscode;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateCredentials(authUsername, passcode)) {
      const authData = {
        expiry: Date.now() + (1 * 1 * 5 * 1000),
        username: authUsername
      };
      localStorage.setItem(`${featureName}_auth`, JSON.stringify(authData));
      setIsAuthenticated(true);
      toast.success('Authentication successful');
    } else {
      toast.error('Invalid credentials');
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-96">
        <h2 className="text-2xl font-bold mb-6 text-center">
          {featureName === 'freeGameScheduler' ? 'Free Game Scheduler' : 'Bonus Management'} Access
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Username</label>
            <input
              type="text"
              value={authUsername}
              onChange={(e) => setAuthUsername(e.target.value.toLowerCase())}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Passcode</label>
            <input
              type="password"
              value={passcode}
              onChange={(e) => setPasscode(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
          <div className="flex justify-between gap-2">
          <button
            type="submit"
            className="w-full bg-blue-600 text-white rounded-md py-2 px-4 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Login
          </button>
          <button className="w-full bg-red-600 text-white rounded-md py-2 px-4 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2" onClick={() => {setIsAuthenticated(false); window.location.reload()}}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeatureAuth;